module.exports = __webpack_public_path__ + "img/igroove-logo.eac30b42.svg";